import { Grid, Typography } from '@mui/material'
import React from 'react'

const AppFooterCopyRight = () => {
    return (
        <Grid container padding={2} spacing={0} sx={{ backgroundColor: '#747474', height:50 }}>
            <Grid item xs={12} sm={12} md={12}>
                <Typography textAlign={'center'}>Copyright 2026 | Tier 1 Asset ARS Portal</Typography>
            </Grid>
        </Grid>
    )
}
export default AppFooterCopyRight